'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var payCycleMap = {
  12: 'monthly',
  24: 'semi-monthly',
  26: 'bi-weekly',
  52: 'weekly'
};

exports.default = function (payCycle) {
  return payCycle in payCycleMap ? payCycleMap[payCycle] : '';
};
//# sourceMappingURL=getLabel.js.map


//////////////////
// WEBPACK FOOTER
// ../benefit-price/lib/getLabel.js
// module id = 671
// module chunks = 0